<template>
  <div class="audio-player">
    <div class="audio-player-inner">
      <f7-button @click="toggleAudio">
        <f7-icon
          :f7="audio ? 'pause_circle_fill' : 'arrowtriangle_right_circle_fill'"
          :color="type === 'sent' ? 'white' : 'blue'"
          size="42"
        ></f7-icon>
      </f7-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioPlayer',

  props: {
    src: {
      type: String,
      required: true
    },

    type: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      audio: null
    };
  },

  methods: {
    toggleAudio() {
      if (!this.audio) {
        this.audio = new Audio();

        this.audio.addEventListener('loadedmetadata', this.play);
        this.audio.addEventListener('ended', () => {
          this.stop();
        });

        this.audio.src = this.src;
      } else {
        this.stop();
      }
    },

    play() {
      this.audio.play();
    },

    stop() {
      this.audio.removeEventListener('loadedmetadata', this.play);
      this.audio.removeEventListener('ended', this.stop);
      this.audio = null;
    }
  }
};
</script>

<style lang="less">
.audio-player {
  --f7-button-height: auto;
  --f7-button-padding-horizontal: 0;
}
</style>
